<template>
    <div
        class="form-group"
        style="border: 1px solid #ddd; padding: 10px;"
    >
        <div class="row">
            <ShowRuleDefinition
                v-if="!isEditDefinitionVisible"
                :questions="questions"
                :index="index"
                :rule-id="ruleId"
                :question_id="question_id"
                :operator="operator"
                :selected-answers="selectedAnswers"
                :input-answer="inputAnswer"
                :definition-id="definitionId"
            />
            <EditRuleDefinition
                v-if="isEditDefinitionVisible"
                :questions="questions"
                :index="index"
                :rule-id="ruleId"
                :initial-question-id="question_id"
                :initial-operator="operator"
                :initial-selected-answers="selectedAnswers"
                :initial-input-answer="inputAnswer"
                :definition-id="definitionId"
                @update-rule-definition="updateDefinition"
                @cancel-edit="isEditDefinitionVisible = false"
            />

            <div class="col-md-12" style="margin-top: 8px; margin-bottom: 16px;" v-if="!isEditDefinitionVisible">
                <button :disabled="isSurveyActive" @click="remove" class="btn btn-danger">
                    <i class="fa fa-trash"/>
                    <span>{{ _t('Delete rule definition') }}</span>
                </button>
                <button :disabled="isSurveyActive" class="btn btn-warning" @click="isEditDefinitionVisible=true">
                    <i class="fa fa-pencil"/>
                    <span>{{ _t('Edit') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import EditRuleDefinition from "./EditRuleDefinition";
import ShowRuleDefinition from "./ShowRuleDefinition";
import Swal from "sweetalert2";

export default {
    name: "RuleDefinition",
    components: {EditRuleDefinition, ShowRuleDefinition},
    props: [
        'questions',
        'index',
        'ruleId',
        'question_id',
        'operator',
        'selectedAnswers',
        'inputAnswer',
        'definitionId',
        'surveyId',
        'isSurveyActive'
    ],

    data() {
        return {
            isEditDefinitionVisible: false
        }
    },
    methods: {
        remove() {
            this.$emit('remove-rule-definition', {
                ruleId: this.ruleId,
                ruleDefinitionId: this.definitionId
            });
        },
        updateDefinition(data) {
            this.$emit('update-rule-definition')
            axios.put(`/survey/${this.surveyId}/rule/${this.ruleId}/rule-definition/${this.definitionId}`, data)
                .then((res) => {
                    this.$emit('update-rule-definition', data)
                    this.isEditDefinitionVisible = false;
                    Swal.fire({
                        text: _t("Rule definition updated successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/RuleDefinition.vue